import { CaretDownOutlined, DeleteOutlined, DownOutlined, PlusOutlined } from '@ant-design/icons';
import { FormInstance, Select } from 'antd';
import { memo, useEffect, useMemo, useState } from 'react';
import { CustomerFieldV2, getListOperatorFieldConditionsGroup, getListOperatorFieldValueGroup, IOperatorFieldGroup, IOperatorFieldGroupV2, IVConditionFilterV2 } from '../../../../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { ISelectOption } from '../../../../../../../../api/selectOptions/selectOptionsApi';
import { mapToSelectOptions } from '../../../../../../../../until';
import '../../../../../style.scss';
import { initCondition, initInfoOperator, toAddPayload } from '../../../../Modal/ModalAddAndEditCondition';
import RenderInputType from './RenderInputType';
import useDebounce from '../../../../../../../../hook/useDebounce';
import { filterInfoOperatoToConditions } from '../../../../../../../../apiSync/customerGroup/customerGroupApi';
import { convertNationwideTree } from '../../../../../../../../api/unit/unitApi';
import { OptionData } from '../../../../../../../CustomersV2/indexV2';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../../../../../../store/slices/infoUserSlice';

interface props {
    options: OptionData[]

    selectableOptions: OptionData[]
    //mơi
    infoOperatorTmp: IVConditionFilterV2
    setInfoOperatorTmp: React.Dispatch<React.SetStateAction<IVConditionFilterV2>>
    setSearchListFilter: (e: string) => void
}

const ConditionGroupOther: React.FC<props> = ({
    selectableOptions,
    options,

    //mơi
    infoOperatorTmp,
    setInfoOperatorTmp,
    setSearchListFilter
}) => {
    const { unitTemp } = useSelector(selectorInfoUser)

    const { conditions } = infoOperatorTmp

    const [openMap, setOpenMap] = useState<Record<number, boolean>>({});
    const [expandMap, setExpandMap] = useState<Record<number, string[]>>({});
    const [searchText, setSearchText] = useState('');
    const selectedIdsOperator = useMemo(() => {
        return new Set(
            conditions ?
                conditions
                    ?.map(o => o.CustomerField?.value)
                    .filter((v): v is number => typeof v === 'number') :
                new Set()
        );
    }, [conditions]);

    const toggleGroup = (
        i: number,
        groupKey: string
    ) => {
        setExpandMap(prev => {
            const current = prev[i] || [];

            return {
                ...prev,
                [i]: current.includes(groupKey)
                    ? current.filter(x => x !== groupKey)
                    : [...current, groupKey],
            };
        });
    };


    // SL trường AND/OR
    const handleChangeLogic = (index: number, value: 'AND' | 'OR' | 'ALL') => {
        setInfoOperatorTmp((prev) => {
            if (!prev?.conditions?.[index]) return prev;
            const updatedConditions = [...prev.conditions];
            const current = updatedConditions[index];

            updatedConditions[index] = {
                ...current,
                logicOperator: value,
            };
            return { ...prev, conditions: updatedConditions };
        });
    };



    //sL diều kiện  // thay đổi trường
    const handleChangeField = useDebounce(async (index: number, customerField?: IOperatorFieldGroup,) => {
        if (!customerField?.id) {
            setInfoOperatorTmp((prev) => {
                if (!prev?.conditions?.[index]) return prev;

                const updatedConditions = [...prev.conditions];
                const current = updatedConditions[index];

                updatedConditions[index] = {
                    ...current,
                    CustomerField: undefined,
                    conditionData: undefined,
                    condition: undefined,
                    value: undefined, // hoặc null nếu bạn muốn "có giá trị rỗng"
                };

                return { ...prev, conditions: updatedConditions };
            });
            return
        }

        const customerFieldTmp: CustomerFieldV2 = {
            inputType: customerField.inputType,
            type: customerField.type,
            value: customerField.id,
            label: customerField.fieldLabel,
            fieldCode: customerField.fieldCode
        }

        const rs = await getListOperatorFieldConditionsGroup(customerField.id)
        if (rs.status) {
            const conditionData = mapToSelectOptions(rs.data);
            const firstCondition = conditionData?.[0];

            setInfoOperatorTmp((prev) => {
                if (!prev?.conditions?.[index]) return prev;

                const updatedConditions = [...prev.conditions];
                const current = updatedConditions[index];

                updatedConditions[index] = {
                    ...current,
                    CustomerField: customerFieldTmp,
                    conditionData: conditionData,
                    condition: firstCondition,
                    value: undefined,
                };

                return { ...prev, conditions: updatedConditions };
            });

            if (firstCondition) {
                handleChangeFieldCondition(index, customerField.id, firstCondition);
            }
        }

    }, 500)

    //giá trị theo id và dk
    const handleChangeFieldCondition = useDebounce(async (index: number, fieldId: number, condition?: ISelectOption) => {

        if (!condition?.value) {
            setInfoOperatorTmp((prev) => {
                if (!prev?.conditions?.[index]) return prev;

                const updatedConditions = [...prev.conditions];
                const current = updatedConditions[index];

                updatedConditions[index] = {
                    ...current,
                    condition: undefined,
                    value: undefined, // hoặc null nếu bạn muốn "có giá trị rỗng"
                };

                return { ...prev, conditions: updatedConditions };
            });
            return
        }

        const conditions = filterInfoOperatoToConditions(infoOperatorTmp)
        const rs = await getListOperatorFieldValueGroup(
            fieldId, condition.value, conditions, unitTemp
        )
        if (rs.status) {
            const isAdd =
                (rs.data.inputType === "date" ? true : false) ||
                (rs?.data?.value === null || rs?.data?.value === undefined) ||
                (Object.hasOwn((rs?.data?.value ?? {}) as object, 'valueNumberMin'))
            if (rs.data.inputType === "dropdown") {
                setInfoOperatorTmp((prev) => {
                    if (!prev?.conditions?.[index]) return prev;

                    const updatedConditions = [...prev.conditions];
                    const current = updatedConditions[index];

                    let optionsDataTmp = []
                    if (rs?.data?.type) {
                        optionsDataTmp = convertNationwideTree(rs.data.value)
                    } else {
                        optionsDataTmp = rs.data.value
                    }

                    updatedConditions[index] = {
                        ...current,
                        CustomerField: current.CustomerField ? { ...current.CustomerField, type: rs.data.type } : current.CustomerField,
                        condition: condition,
                        isAdd,
                        optionsData: optionsDataTmp,
                        value: undefined, // hoặc null nếu bạn muốn "có giá trị rỗng"
                    };

                    return { ...prev, conditions: updatedConditions };
                });
            } else {
                setInfoOperatorTmp((prev) => {
                    if (!prev?.conditions?.[index]) return prev;

                    const updatedConditions = [...prev.conditions];
                    const current = updatedConditions[index];

                    updatedConditions[index] = {
                        ...current,
                        CustomerField: current.CustomerField ? { ...current.CustomerField, type: rs.data.type } : current.CustomerField,
                        condition: condition,
                        isAdd,
                        value: rs.data?.value, // hoặc null nếu bạn muốn "có giá trị rỗng"
                    };

                    return { ...prev, conditions: updatedConditions };
                });
            }

        }

    }, 500)

    // Helper: options cho 1 dòng i, giữ lại giá trị đang chọn của chính dòng đó
    // const getOptionsForRow = (rowIndex: number) => {
    //     const currentFieldId = infoOperatorTmp.conditions[rowIndex]?.CustomerField?.value;
    //     return sLOperatorFieldGroup.filter(
    //         fg => !selectedIdsOperator.has(fg.id) || fg.id === currentFieldId
    //     );
    // };


    // 2) Thêm dòng
    const handleAddOperator = () => {
        setInfoOperatorTmp(prev => ({
            ...prev,
            conditions: [...prev.conditions, initCondition],
        }));
    };

    const handleDeleteOperator = (rowIndex: number) => {
        setInfoOperatorTmp(prev => {
            if (!prev?.conditions?.[rowIndex]) return prev;
            const conditions = prev.conditions.filter((_, i) => i !== rowIndex);
            return { ...prev, conditions };
        });
    }

    // 3) Đặt lại toàn bộ
    const handleResetOperator = () => {
        setInfoOperatorTmp(initInfoOperator)
    };


    // useEffect(() => {
    //     // console.log(infoOperatorTmp);
    //     const filteredInfoOperatorADD = toAddPayload(infoOperatorTmp)
    //     // const filteredInfoOperator = filterInfoOperator(infoOperatorTmp)
    //     // console.log(filteredInfoOperator);
    //     // console.log(filteredInfoOperatorADD);
    // }, [infoOperatorTmp])

    return (
        <div className="custom-page-css flex flex-col gap-2  ">
            <div className="custom-page-css flex items-center bg-096DD9 rounded py-2 px-2 gap-2 ">
                <div className="custom-page-css flex flex-1 ">
                    <span className='custom-page-css text-base text-white font-regular '>Trường</span>
                </div>
                <div className="custom-page-css flex flex-1 ">
                    <span className='custom-page-css text-base text-white font-regular '>Điều kiện</span>
                </div>
                <div className="custom-page-css flex flex-1">
                    <span className='custom-page-css text-base text-white font-regular '>Giá trị</span>
                </div>
            </div>

            {
                conditions.map((item, i) => (
                    <div
                        key={i}
                        className="custom-page-css flex gap-2 items-start"
                    >
                        <div className="custom-page-css flex flex-1 shrink-0 overflow-hidden">
                            <div className="custom-page-css w-full flex gap-2 ">
                                
                                    <Select
                                        showSearch
                                        className=" w-120px text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector"
                                        popupClassName='position-dropdow custome-select-item h-popUp'
                                        placeholder="--"
                                        options={i !== 0 ? [
                                            {
                                                value: 'AND',
                                                label: 'AND'
                                            },
                                            {
                                                value: 'OR',
                                                label: 'OR'
                                            },
                                        ] : []}
                                        value={i !== 0 ? item.logicOperator : null}
                                        disabled={i === 0}
                                        onChange={(e) => handleChangeLogic(i, e)}
                                    />
                                
                                <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center   py-2-px h-8 justify-between overflow-hidden">
                                    <div className="d-flex align-center  w-full">


                                        <Select
                                            showSearch
                                            onSearch={(value) => {
                                                setSearchText(value);
                                                setSearchListFilter(value);
                                            }}
                                            open={!!openMap[i]}
                                            onDropdownVisibleChange={(open) => {
                                                setOpenMap(prev => ({
                                                    ...prev,
                                                    [i]: open,
                                                }));
                                                if (!open) {
                                                    setSearchText('');
                                                }
                                            }}
                                            value={item?.CustomerField?.value}
                                            placeholder="Chọn trường"
                                            style={{ width: '100%' }}
                                            optionFilterProp="label"
                                            options={selectableOptions}
                                            filterOption={false}

                                            dropdownRender={() => (
                                                <div
                                                    style={{
                                                        maxHeight: 350,
                                                        overflowY: "auto",
                                                    }}
                                                >
                                                    {options.filter((item) => {
                                                        if (!searchText) return true;
                                                        const keyword = searchText.toLowerCase();
                                                        if (item.isGroup) {
                                                            // Giữ group nếu có child khớp
                                                            return options.some(
                                                                (o) => !o.isGroup && o.parentKey === item.key && o.label.toLowerCase().includes(keyword)
                                                            );
                                                        }
                                                        return item.label.toLowerCase().includes(keyword);
                                                    }).map((item) => {
                                                        if (item.isGroup) {
                                                            const expanded = expandMap[i]?.includes(item.key);

                                                            return (
                                                                <div
                                                                    key={item.key}
                                                                    onClick={() => toggleGroup(i, item.key)}
                                                                    style={{
                                                                        padding: "8px 12px",
                                                                        fontWeight: 600,
                                                                        background: "#fafafa",
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 8,
                                                                    }}
                                                                >
                                                                    <CaretDownOutlined
                                                                        rotate={expanded ? 0 : -90}
                                                                    />
                                                                    {item.title}
                                                                </div>
                                                            );
                                                        }

                                                        const groupKey = item.parentKey;


                                                        if (
                                                            groupKey &&
                                                            !expandMap[i]?.includes(groupKey)
                                                        ) {
                                                            return null;
                                                        }

                                                        // field đang chọn của row hiện tại
                                                        const currentFieldId = conditions[i]?.CustomerField?.value;

                                                        // đã được chọn ở row khác
                                                        const isDisabled =
                                                            selectedIdsOperator.has(item.value) &&
                                                            item.value !== currentFieldId;

                                                        return (
                                                            <div
                                                                key={item.key}
                                                                onMouseDown={(e) => {
                                                                    e.preventDefault();
                                                                }}
                                                                className={` ${isDisabled ? 'items-option-disabled' : 'items-option'}`}
                                                                onClick={() => {
                                                                    if (isDisabled) return;

                                                                    handleChangeField(i, item);
                                                                    setSearchText('');
                                                                    setOpenMap(prev => ({
                                                                        ...prev,
                                                                        [i]: false,
                                                                    }));
                                                                }}
                                                                style={{
                                                                    padding: "8px 32px",

                                                                }}
                                                            >
                                                                {item.label}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        />


                                    </div>
                                    {/* <div className="  h-full d-flex align-center">
                                        <DownOutlined className="text-sm text-98A2B3 " />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className={`custom-page-css flex flex-1 shrink-0`}>
                            <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
                                <div className="d-flex align-center  w-full">
                                    {/* <Select
                                        showSearch
                                        allowClear
                                        className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                                        // popupClassName='position-dropdow custome-select-item h-popUp'
                                        variant="borderless"
                                        suffixIcon={null}
                                        disabled={!item?.CustomerField?.value}
                                        value={item?.condition?.value}
                                        onChange={(val, option: any) =>
                                            handleChangeFieldCondition(i, item?.CustomerField?.value, option?.itemData)
                                        }
                                        onClear={() => handleChangeFieldCondition(i, item?.CustomerField?.value, undefined)}
                                    >
                                        {
                                            item?.conditionData?.map(optionItem => (
                                                <Select.Option
                                                    key={optionItem.value}
                                                    value={Number(optionItem.value)}
                                                    label={optionItem.label}
                                                    itemData={optionItem}>
                                                    {optionItem.label}
                                                </Select.Option>
                                            ))
                                        }
                                    </Select> */}

                                    <Select
                                        showSearch
                                        allowClear
                                        className="w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector"
                                        variant="borderless"
                                        suffixIcon={null}
                                        disabled={!item?.CustomerField?.value}
                                        value={item?.condition?.value}
                                        optionFilterProp="label"
                                        onChange={(val, option: any) =>
                                            handleChangeFieldCondition(
                                                i,
                                                item?.CustomerField?.value,
                                                option?.itemData
                                            )
                                        }
                                        onClear={() =>
                                            handleChangeFieldCondition(
                                                i,
                                                item?.CustomerField?.value,
                                                undefined
                                            )
                                        }
                                    >
                                        {
                                            item?.conditionData?.map(optionItem => (
                                                <Select.Option
                                                    key={optionItem.value}
                                                    value={Number(optionItem.value)}
                                                    label={optionItem.label}
                                                    itemData={optionItem}
                                                >
                                                    {optionItem.label}
                                                </Select.Option>
                                            ))
                                        }
                                    </Select>

                                </div>
                                <div className="  h-full d-flex align-center">
                                    <DownOutlined className="text-sm text-98A2B3 " />
                                </div>
                            </div>
                        </div>
                        <div className="custom-page-css flex items-center gap-2 flex-1 overflow-hidden">
                            <RenderInputType
                                disabled={!item?.condition?.value}
                                index={i}

                                itemCondition={item}
                                setInfoOperatorTmp={setInfoOperatorTmp}

                            />
                            <DeleteOutlined
                                className={`text-F5222D ${conditions.length === 1 ? "d-none" : ""}`}
                                onClick={() => handleDeleteOperator(i)}
                            />
                        </div>
                    </div>
                ))
            }

            <div className="custom-page-css flex items-center justify-between gap-1">
                <div
                    className="custom-page-css flex items-center gap-1 cursor-pointer"
                    onClick={handleAddOperator}
                >
                    <div className="custom-page-css h-4 w-4 flex items-center justify-center rounded-full bg-E1E4E9">
                        <PlusOutlined className='custom-page-css text-98A2B3 text-xs' />
                    </div>
                    <span className='custom-page-css text-base text-667085 font-regular'>Thêm điều kiện</span>
                </div>
                <span
                    className='custom-page-css text-base text-1890FF font-regular cursor-pointer'
                    onClick={handleResetOperator}
                >Đặt lại bộ lọc</span>
            </div>

            {/* <div className="custom-page-css flex w-fit items-center gap-1 cursor-pointer border-b-1890FF"
                onClick={() => {
                    setPreview(true)
                    setPrivate(false)
                }}
            >
                <span className='custom-page-css text-base text-1890FF font-regular'>Xem trước danh sách khách hàng của nhóm</span>
                <img src={Up_right} alt="" />
            </div> */}
        </div>
    )
}
export default memo(ConditionGroupOther)